import React from "react";
import SEO from "components/SEO/SEO";

const Terms_condition = () => {
  return (
    <div className="container">
      <SEO
        title="Terms and Conditions"
        description="Read the Nomadroof terms and conditions governing the use of our student accommodation platform in Lima, Peru."
        canonical="/terms"
        noIndex={true}
      />
      <div className="py-10">
        <h2 className="text-2xl font-semibold text-orange-500 pb-4">
          Terms And Conditions
        </h2>
        <hr />
        <p className="text-sm text-gray-800 dark:text-gray-100 mt-4 leading-relaxed">
          BY USING THE SITE, APPLICATION AND/OR SERVICES, YOU AGREE TO COMPLY
          WITH AND BE LEGALLY BOUND BY THESE TERMS AND CONDITIONS (“TERMS”),
          WHETHER OR NOT YOU BECOME A REGISTERED USER. THESE TERMS GOVERN YOUR
          ACCESS TO AND USE OF THE SITE, APPLICATION AND SERVICES AND ALL
          NOMADROOF CONTENT, AND CONSTITUTE A BINDING LEGAL AGREEMENT BETWEEN
          YOU AND NOMADROOF. IF YOU DO NOT AGREE TO THESE TERMS, YOU HAVE NO
          RIGHT TO OBTAIN INFORMATION FROM OR OTHERWISE CONTINUE USING THE SITE,
          APPLICATION AND/OR SERVICES. FAILURE TO USE THE SITE, APPLICATION
          AND/OR SERVICES IN ACCORDANCE WITH THESE TERMS MAY SUBJECT YOU TO
          CIVIL AND CRIMINAL PENALTIES.
        </p>
        <p className="text-sm text-gray-800 dark:text-gray-100 mt-2 leading-relaxed">
          THE SITE, APPLICATION AND SERVICES OF NOMADROOF CONSIST OF AN ONLINE
          PLATFORM FOR HOUSING ACCOMMODATION IN WHICH HOSTS MAY CREATE LISTINGS
          FOR ACCOMMODATION AND TENANTS (DEFINE BELLOW) MAY LEARN ABOUT AND BOOK
          ACCOMMODATIONS DIRECTLY WITH HOSTS. YOU UNDERSTAND AND AGREE THAT
          NOMADROOF IS NOT A PARTY TO ANY AGREEMENTS ENTERED INTO BETWEEN HOSTS
          AND TENANTS, NOR IS NOMADROOF A REAL ESTATE BROKER, AGENT OR INSURER.
          NOMADROOF HAS NO CONTROL OVER THE CONDUCT OF HOSTS, TENANTS AND OTHER
          USERS OF THE SITE, APPLICATION AND SERVICES OR ANY ACCOMMODATIONS, AND
          DISCLAIMS ALL LIABILITY IN THIS REGARD.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          1. Key Terms
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Nomadroof Content”
          </span>
          <span className="text-sm">
            means all Content that Nomadroof makes available through the Site,
            Application, Services, or its related promotional campaigns and
            official social media channels, including any Content licensed from
            a third party, but excluding Member Content.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Content”
          </span>
          <span className="text-sm">
            means text, graphics, images, music, software (excluding the
            Application), audio, video, information or other materials.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Accommodation or property”
          </span>
          <span className="text-sm">
            means residential and other type of properties.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Listing”
          </span>
          <span className="text-sm">
            means an Accommodation that is listed by a Host as available for
            rental via the Site, Application, and Services.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “User”
          </span>
          <span className="text-sm">
            means a person who uses, navigates or register through
            http://www.nomadroof.com and any other websites through which
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            Nomadroof
          </span>
          <span className="text-sm">
            makes the Services available (collectively, the “Site”) and as an
            any mobile devices (the “application”).
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Host”
          </span>
          <span className="text-sm">
            means a user who agrees with NOMADROOF on publishing a Listing via
            the Site, Application and Services in order to be booked by Users.
            Hosts can be individuals, companies or any other entity that owns or
            manage properties to rent for more than one month.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Tenants”
          </span>
          <span className="text-sm">
            means a user who requests from a Host a booking of an accommodation
            via the Site, Application or Services, or a user who stays at an
            Accommodation and is not the Host for the associated accommodation
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Check in / roof in date”
          </span>
          <span className="text-sm">
            means the date in which the Tenant moves in the Accommodation.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Check out / roof out date”
          </span>
          <span className="text-sm">
            means the date in which the Tenant moves out the Accommodation.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “You”
          </span>
          <span className="text-sm">
            means a User, Tenant or Host (as applicable).
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Booking Request”
          </span>
          <span className="text-sm">
            means when a Tenant clicks on “Booking Request” button through the
            Site, Application or Services. The Booking request contains the
            check-in dates, check-out dates, tenant’s service fee and the amount
            of the first month’s rent corresponding to the Accommodation. Host
            may decide whether to confirm or reject that booking request, as
            stated on the Site, Application or Services. Different Booking
            Request Periods may apply in different places.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Booking service fee”
          </span>
          <span className="text-sm">
            means the fee paid through the site by Tenants when he/she books
            through the Site, Application or Services.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “Marketing Material”
          </span>
          <span className="text-sm">
            means photography, videography, and any other marketing material
            designed, created and developed by Nomadroof or any of its
            subcontractors.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            ”Host Service Fee”
          </span>
          <span className="text-sm">
            means the fee agreed by the Host to be discounted from the first
            month’s rent that he/she receives when a Tenant pays the booking
            through Site, Application or Services .The fee is calculated based
            on the total contract value of the booking confirmed by the Host.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            “User Content”
          </span>
          <span className="text-sm">
            means all Content that a User posts, uploads, publishes, submits,
            transmits, or includes in their Listing, Member profile or Nomadroof
            promotional campaign to be made available through the Site,
            Application or Services.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            Tax” or “Taxes”
          </span>
          <span className="text-sm">
            mean any sales taxes, value added tax (VAT), and other similar
            municipal, province or state indirect or other withholding and
            personal or corporate income taxes
          </span>
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          2. About these Terms and Conditions
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          YOU ACKNOWLEDGE AND AGREE THAT, BY ACCESSING OR USING THE SITE,
          APPLICATION OR SERVICES OR BY DOWNLOADING OR POSTING ANY CONTENT FROM
          OR ON THE SITE, VIA THE APPLICATION OR THROUGH THE SERVICES, YOU ARE
          INDICATING THAT YOU HAVE READ, AND THAT YOU UNDERSTAND AND AGREE TO BE
          BOUND BY THESE TERMS. YOU ALSO CONFIRM THAT YOU OBLIGE THE NATIONAL
          LAWS AND OBLIGATIONS OF THE COUNTRY WITH RESPECTS TO RENTING AND
          SUBLETTING. IF YOU DO NOT AGREE TO THESE TERMS, THEN YOU HAVE NO RIGHT
          TO ACCESS OR USE THE SITE, APPLICATION, SERVICES, OR CONTENT.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          If you accept or agree to these Terms on behalf of a company or other
          legal entity, you represent and warrant that you have the authority to
          bind that company or other legal entity to these Terms and, in such
          event, “you” and “your” will refer and apply to that company or other
          legal entity.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          3. Amendments and Modifications
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof reserves the right to amend, modify and update its Terms and
          Conditions, including booking fees at any time. When we do, we will
          revise the updated date at the top of these Terms on the Site and/or
          Application or provide you with notice of the modification. By
          continuing to access or use the Site, Application or Services after we
          have posted a modification on the Site or via the Application or have
          provided you with notice of a modification, you are indicating that
          you agree to be bound by the modified Terms.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          4. Nomadroof’s Site, Application and Services
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Site, Application and Services served as a platform that allows
          Tenants to browse, search and book Accomodation at the Locations
          available and allows Hosts to advertise Accommodations to Tenants.The
          Accomodations are included in Listings on the Site, Application and
          Services by Nomadroof.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof provides booking services to Tenants, and Hosts, but it does
          not offer Accommodation to Tenants on its behalf nor does owns, sells,
          resell, furnish, provide, rent, re-rent, lease, sublease, manage or
          control properties. Any rental, lease or sublease agreement shall be
          entered into between the Tenant and the Host directly. Nomadroof will
          not be a party to such agreement and will have no rights or
          obligations arising out of it.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          5. Registration
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The registration of users is required in order to make use of the Site
          and Application of Nomadroof. Hosts register when putting a listing of
          their accommodation online. Tenants register when contacting Host or
          requesting a booking to an accommodation. Registration is free of
          charge and requires that users accept Nomadroof’s General Terms and
          Conditions. The user agreement between Nomadroof and the user arises
          on acceptance of the terms and conditions.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Registration is available only to natural persons, legal persons and
          partnerships that are fully legally competent. The registration of a
          legal person or partnership may be performed only by a natural person
          with power of representation who must be named. When registering, only
          individual persons may be given as the owner of the user account (i.e.
          no married couples or families).
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Registration as a Host is accepted or denied by Nomadroof as its sole
          discretion. Nomadroof has the right to publish or not to publish a
          listing of an accommodation by a Host.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Registration as a Host is accepted or denied by Nomadroof as its sole
          discretion. Nomadroof has the right to publish or not to publish a
          listing of an accommodation by a Host.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          When registering, the user undertakes to provide accurate, up-to-date
          and complete information as required by the registration form, in
          particular first and last name, current address (not a PO box), a
          valid e-mail address and, where appropriate, the name of the company
          and an authorized representative. The data must be up-to-date and
          correct at all times. Multiple registrations under different member
          names are prohibited. User can register via Facebook account, Gmail
          account, or email adress. When registering, the user chooses a
          password to accompany his/her email address.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The user can receive contractual declarations at his/her stated e-mail
          address.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          A user account and password is personal and can therefore not be
          transferred to any other person. The user is liable to Nomadroof for
          all actions performed ushing his/her user account, unless the user is
          not responsible for the misuse of his/her user account.Once the user
          is aware that third parties have access to his/her user data or have
          otherwise gained access to his/her user account, he/she must notify
          Nomadroof of this immediately. Nomadroof is entitled to then block the
          user account until the situation has been clarified.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          6. User Obligations and Information Displayed in the Site, Application
          and Services
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The user is the solely responsible for all content that he/she places
          on the platform. In his/her relationship to Nomadroof, he/she commits
          not to place illegal content on the platform and to refrain from
          actions that violate laws.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof tries hard to ensure that all information published on the
          Site, Application and Services is clear, accurate, complete and not
          misleading. We also try to ensure that only Accommodation that meets
          certain standards of cleanliness, decor, building safety and finish,
          facilities and customer service are listed on the Site, Applications
          and Services. However, as we do not provide the Accommodation, we
          cannot guarantee this. The Host is responsible for ensuring that the
          accommodation he/she offers is described correctly and completely.
          He/She must provide the information in Nomadroof’s required fields at
          a minimum so that the accommodation and the offer are described with
          sufficient accuracy. We do not verify the accuracy or currency of any
          information uploaded or provided to us by Hosts unless we have
          expressly stated that we do. In addition, Hosts are free to stipulate
          further conditions such as the amount of a security deposit, the cost
          of cleaning service, etc
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The user undertakes to keep the information in his/her user account
          up-to-date and accurate at all times, i.e. to correct it immediately
          in the event of a change or delete the room from the platform in case
          tenant and host have agreed on rental. If you are a Host, you
          acknowledge and agree that you are the solely responsible for the
          content of the information uploaded or provided to us in respect of
          any Accommodation offered on the Site, Application and Services.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Tenant acknowledge and agree that we will have no liability in respect
          of any information uploaded to the Site, Application and Services or
          provided to us by Host about the Accommodation and that your proper
          remedy in respect of any loss or damage you may suffer arising out of
          or in connection with the information displayed in respect of the
          Accommodation is against the relevant Host. If accommodation has been
          verified by Nomadroof, Nomadroof shall be responsible for the verified
          information only. However, Nomadroof shall not be liable for any
          changes to the Accommodation after its verification..
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Regarding the accommodation of a Host that has been verified by
          Nomadroof, Host acknowledge that the photos taken of his/her
          accommodation, and/or any other marketing materials performed by
          Nomadroof related to his/her accommodation, belongs to Nomadroof and
          will not be send over to him/her, but will be uploaded to the
          corresponding accommodation’s listings. Host automatically grants
          permission to Nomadroof to upload the photos to the corresponding
          listing on his/her behalf by accepting the photography session and/or
          the marketing material session performed by Nomadroof or their
          contractual third-parties.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Host has the option to ask Nomadroof’s staff for language translation
          of the description and information that Host add on his/her
          accommodation listing . Nomadroof will provide such service at its
          sole discretion and if it does, Nomadroof will email a draft of such
          translation to be revised by Host. Host can reply to the email sent,
          by confirming the acceptance or denial of such language translation.
          If accepted, host automatically grants permission to Nomadroof to post
          such translation in the Host’s listing on his/her behalf. If there is
          no reply of the email regarding the language translation within 48
          hours, Nomadroof understands that Host has accepted the translation as
          it is and will post it on his/her behalf. The language translation may
          contain syntax errors as it is a simple language conversion. Host
          acknowledge and agree that he/she is the solely responsible for the
          content of such language translation. Host and tenant knowledge and
          agree that Nomadroof shall not be liable of such language translation
          as it is perform by Nomadroof in good faith.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Host acknowledges and agrees that Nomadroof does not act as an
          insurer or as a contracting agent for you. Nomadroof recommends that
          Hosts obtain appropriate insurance for their Accommodations.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          We reserve the right to remove without notice all or any part of any
          Accommodation listed on the Site, Applications and Services in respect
          of which we receive a complaint (or otherwise conclude) that it is out
          of date, inaccurate or breaches the rights of a third party. We will
          use reasonable efforts to process and act on such complaints
          reasonably and promptly.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Tenants are advised to read any documentation carefully and ensure
          that they understand the cost of the Accommodation (i.e. the rent and
          any other costs) and the terms and duration of the rental, lease or
          sublease agreement and any restrictions on the usage to which the
          Accommodation can be put.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          7. Content and Rights
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Within the framework of the Site, Application and/or Services, hosts
          can present to potential tenants using a variety of media. Certain
          rules must be complied with to ensure that the various media are
          utilized legally so that neither the user nor Nomadroof can be made
          liable. These rules derive, for example, from laws protecting
          copyrights and brands in addition to these Terms and Conditions.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof saves for the user the multimedia content uploaded by
          him/her (images, text, etc.) or merely arranges the necessary memory
          space and access to it. Users themselves are the solely responsibles
          for the content they upload to the Site and/or Application -unless
          stated otherwise by Nomadroof in these Terms and Conditions-and
          indemnify Nomadroof against all third-party claims resulting from
          this. In particular, this indemnification also includes the costs of
          appropriate prosecution and legal defence.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Users will ensure that the uploaded content does not violate
          applicable law or legal provisions, common decency, or in particular
          third-party rights (naming rights, personality rights, copyright, data
          protection rights, etc.). In particular, users undertake not to upload
          content that violates the terms of any applicable laws or treaties.
          The user also undertakes not to utilize content that is pornographic,
          glorifies violence, or is race baiting. This also applies to the
          sending of e-mails and other electronic communication media of the
          Site, Application and/or Services.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          By uploading multimedia content, users transfer to Nomadroof a free,
          revocable, unlimited, non-local right of use that can be sub-licensed
          to the multimedia content uploaded to Nomadroof by the user. In
          particular, the right of use comprises the right to process the
          multimedia content for the purposes of the platform and to make it
          available to the public offline, in printed or electronic form, by
          wired or wireless connection, in such a way that it is accessible to
          members of the public at places and times of their choosing, including
          playback on their chosen receiver terminal that allows online access,
          in particular stationary and portable computer and mobile handheld
          devices such as smartphones, tablets and similar equipment. The usage
          rights also include the right to integrate multimedia content,
          including advertising media, on websites from Nomadroof’s contractual
          partners.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof is free to use any comments, information, pictures or ideas
          contained in any communication user may send to Nomadroof without
          compensation, acknowledgement or payment to user for any purpose
          whatsoever, including, but not limited to, developing, manufacturing
          and marketing products and services and creating, modifying or
          improving the services or website or other products or services. For
          the avoidance of doubt, all such information will be deemed by
          Nomadroof to be non-confidential and non-proprietary, and user agrees
          that such information may be used by Nomadroof without any limitation
          whatsoever.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          User explicitly agrees that Nomadroof is free to read any messages
          sent between users. Nomadroof may read these messages to improve user
          experience, solve conflicts between users or for other reasons
          Nomadroof deems appropriate.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          User agrees that Nomadroof is free to republish and make use of any
          information published by you on the Site, Application and/or Services
          without acknowledging user as the source of such information and/or
          creator of such content. In general however, Nomadroof will make an
          attempt to provide a link back to user’s page when posting content on
          other third party sites, such as Facebook or any of our contractual
          partners. User hereby irrevocably waives all moral rights to any
          content placed on the Site, Application and/or Services.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          User explicitly allows Nomadroof to use and show user’s (Facebook)
          profile picture on its website www.nomadroof.com.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The content offered via Nomadroof is protected by copyright. The Site,
          Application and Services are generally accessed and utilized
          individually by a natural person using a web browser. The use of
          technologies such as web spiders, crawlers, or similar programs, the
          purpose of which is not just the indexing of content but also the mass
          accessing and saving of content of Site, Application and Services is
          prohibited. This also applies in particular to technologies that
          enable so-called screen scraping and other third-party services.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          In the event of a violation of these prohibitions and the guidelines
          of these Terms and Conditions, Nomadroof is entitled to refuse
          acceptance of content, to delete and block content immediately and to
          delete the pages and links to them immediately. In such cases the user
          has no right to the restoration of his/her multimedia content on the
          internet platform or the release of his/her deleted user profile.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          8. Booking Process
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The use of the secure booking service, offered by Nomadroof, is
          mandatory for all Site and Application users
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Tenant may submit a Booking Request for Accommodation through
          Nomadroof’s Site, Application and Services. Tenant must select the
          dates and Accommodation that he/she wishes to book and then click the
          “Booking Request” button. The User will receive an email confirming
          that a Booking Request has been submitted.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Tenant warrants that he/she is of legal age to enter into a
          contract such as a Rental, Lease or Sublease Agreement in the country
          where the Accommodation is located and acknowledges that, if the
          Tenant is in breach of this warranty, then Nomadroof shall be entitled
          to retain any Service Fee that has been paid by the Tenant as
          compensation for breach of this warranty by the Tenant. It is the
          Tenant’s responsibility to insure that he/she can legally contract
          with the Host.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Host receives the booking request and he/she has the right to
          accept it or reject it within 48 hours the booking request has been
          submited by Tenant. If he/she accepts the booking request, the system
          creates and sends to Tenant an invoice for authorization for the First
          Month’s Payment, Service Fee and Reservation Deposit (if applicable).
          This invoice is sent through a weblink notification via e-mail and it
          can be seen in My Reservations, located in Tenant’s Dashboard
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Tenant will be asked to complete certain personal details and
          provide payment details for the First Month’s Rent Payment, Service
          Fee and Reservation Deposit (if applicable) as part of a Booking
          Request.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Once the payment of User is confirmed, Nomadroof will notified both
          parties that the booking request has been successful.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          9. Confirmation of a Booking
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Host can accept or reject any Booking Request. If the Booking
          Request is rejected, Nomadroof will promptly notify the User by email
          and immediately and will make reasonable efforts to suggest other
          suitable accommodations. If the Booking Request has been accepted, a
          confirmation email will be sent to both parties stating the process
          for completing the Booking. To complete the Booking, Tenant will have
          to pay the invoice that Nomadroof will sent him/her which includes the
          First Month’s Rent Payment, the Service Fee and Reservation Deposit
          (if applicable). Once the payment of Tenant is confirmed, Nomadroof
          will promptly notify both parties that the Booking is confirmed.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Once a Booking has been confirmed, it is the Tenant’s responsibility
          to
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (a)
          </span>
          <span className="text-xs">
            comply with any further requirements that the Host or Accommodation
            Provider may have. This may include (but not be limited to) the
            provision of character references and/or guarantor information. This
            information can also be required by the Host or Accommodation
            Provider before accepting the Booking Request. In such cases the
            User will be informed that such information will be required; and
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (b)
          </span>
          <span className="text-xs">
            comply with the Rental, Lease or Sublease Agreement, and to make,
            promptly and in full, all required payments to the Host or
            Accommodation Provider, as may be required either by these Terms of
            Service or the Rental, Lease of Sublease Agreement.
          </span>
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Host agrees that once the Booking Request is paid by Tenant, it is
          bound to provide the Accommodation for the dates and at the price
          stated on the Booking Request and, further, that the details,
          condition and facilities of the Accommodation are not materially
          different from those stated on the Nomadroof’s listing. Failure to do
          so may result in cancellation by the Tenant (who may be entitled to a
          full refund).
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          10. Cancellation Policy & Refunds
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          A Tenant is permitted to cancel a Booking only in accordance with the
          terms of a Rental, Lease or Sublease Agreement, and under the
          cancellation policy stated bellow. Under all cancellation policies,
          the Nomadroof booking service fee is non-refundable unless stated
          otherwise in these Terms and Conditions. The following are the
          cancellation policies.
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (a)
          </span>
          <span className="text-xs">
            If tenant cancels less than 30 days prior the check-in date,
            Nomadroof will not refund the first month’s rent amount already
            captured after the booking confirmation. Thus, the Tenant will lose
            the first month’s rent. Nomadroof will transfer the first month’s
            rent to the host, to compensate the host for the loss of an empty
            room.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (b)
          </span>
          <span className="text-xs">
            If tenant cancels between 30 days and 60 days before the check-in
            date, Nomadroof will refund 50% of the first month’s rent to the
            Tenant. Nomadroof will transfer the other 50% of first’s month rent
            to the host, to compensate the host for the loss of an empty room.
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (c)
          </span>
          <span className="text-xs">
            If tenant cancels with more than 60 days before the check-in date,
            Nomadroof will refund the 100% of the first month’s rent to the
            tenant.
          </span>
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          A refund in other ways different that the ones stated in these Terms
          and Conditions will not be given in other circumstances which include,
          but are not limited to: accommodation that is not according to taste;
          accommodation that is not in line with religious ideology (including
          living with people from another sex); accommodation that is not clean,
          accommodation that turns out to be in a less safe neighborhood;
          accommodation that has noise complaints; accommodation is not suitable
          to the tenant because of medical reasons; accommodation has a minor
          malfunction that could not have been known in advance; the tenant is
          hindered in coming to the accommodation because of a change of plans,
          travel delays, illness or having made a double booking.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          Tenant’s 24 hours check policy
        </p>
        <ul className="list-disc pl-5 text-xs text-gray-800 dark:text-gray-100 space-y-2">
          <li>
            The tenant has the obligation to inform Nomadroof and the Host about
            any claim within 24 hours after the start of the rental, lease or
            sublease period. The tenant has to substantiate his claim and
            provide proof. If Nomadroof finds the tenant’s claim to be
            convincing, it will refund the rent and the booking fee charged by
            Nomadroof to the tenant. If the tenant does not inform Nomadroof
            about any problems within 24 hours from the start of the lease
            onwards, the tenant is expected to have agreed with the room as it
            is. Nomadroof will then transfer the payment of the rent to the
            host.
          </li>
          <li>
            In the case of a dispute between tenant and host or accommodation
            provider, Nomadroof advises parties to solve it themselves. If this
            turns out to be impossible, parties can provide Nomadroof with the
            information and possible proof of the dispute. After taking all the
            provided information into consideration, Nomadroof makes a decision
            about the dispute which will be binding for both parties.
          </li>
        </ul>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          Host Cancellations
        </p>
        <ul className="list-disc pl-5 text-xs text-gray-800 dark:text-gray-100 space-y-2">
          <li>
            Should a Host cancel a booking reservation after the Tenant’s
            payment of the first month’s rent payment, Tenant is entitled to a
            full refund of the service fee and first month’s rent payment and
            reservation deposit (if applicable).
          </li>
        </ul>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          11. First Month’s Rent Payment
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The First Month’s Rent Payment is a contractual reservation fee
          payable by the Tenant to Nomadroof, which it receives on behalf of the
          Host and holds in trust for the Host.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Within one business day of the Check In Date, unless otherwise agreed
          in writing with Nomadroof, Nomadroof shall pay to the Host, subject to
          deductions for the Nomadroof host fee, the First Month’s Rent and
          Holding Deposit (if applicable). The host fee is a percentage of the
          First Month’s Rent that is deducted when transfering the First Mont’s
          Rent to Host.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof is not a member of any deposit protection scheme in respect
          of such First Month’s Rent Payment and will not be holding any damages
          deposit or performance deposit for the Host/ which they request from
          the Tenant.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          The Host must ensure that:
        </p>
        <ul className="list-disc pl-5 text-xs text-gray-800 dark:text-gray-100 space-y-2">
          <li>
            A correct PAYPAL or IBAN/BIC bank account is provided. Nomad roof
            will transfer the rent to the bank account provided and is not
            liable if this bank account is not correct. Nomadroof’s obligations
            towards provider will cease to exist once Nomadroof has transferred
            the rent to the bank account provided by host. Whether this bank
            account is correct or not is to remain the risk of the host and does
            not stand in the way of releasing Nomadroof from its liabilities.
          </li>
          <li>
            A correct ID number and full name of Host is provided when Nomadroof
            sends to Host a document via email that has to be fill out with the
            information requested for transferring the first month’s rent. After
            Host send back the document, Nomadroof will transfer the rent to a
            local bank branch where host can picked up the first month’s rent
            minus applicable deductions.
          </li>
          <li>
            The description of the accommodation and the images used do not
            violate the law or third-party rights and that they relate only to
            the host on offer
          </li>
          <li>
            A successfully booked accommodation is indicated accordingly or
            removed from the Site, Application and/or Services;
          </li>
          <li>
            Information uploaded does not constitute references to third-party
            content;
          </li>
          <li>
            He/she complies with public law regulations, particularly those for
            payment, factoring and tax law obligations, which may also include
            any obligations under sales tax law or indirect tax obligations. The
            host will be the solely responsible of the obligations and duties of
            the offer content. Nomadroof is entitled to verify the offer of the
            users and ask for the corresponding proofs.
          </li>
          <li>
            Once a tenant has requested renting the accommodation, host is not
            allowed to request a higher price than requested in the original
            listing.
          </li>
        </ul>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          12. Security Deposit, Cleaning Fee and Other Extra fees
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The host is entitled to charge a security deposit, cleaning fee and
          any other extra fee in his/her listing. If a host demands a security
          deposit, a cleaning fee and other extra fees from the tenant on the
          day of arrival, corresponding information on the amount of the
          security deposit, cleaning fee or other extra fee, and the payment
          method must have already been mentioned in the listing or discusses
          previously in the message center. The amount of the security deposit
          must be stipulated prior to the booking. It must also be clarified in
          advance when the amount must be paid (e.g. upon moving in).
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          If the host did not mention the security deposit, cleaning fee or
          other extra fee when advertising his/her accommodation, but demands
          any of the payments stated above at a later time and the tenant does
          not agree, this constitutes a refusal to render performance by the
          host under the agreed contract. In such cases, the tenant reserves the
          right to cancel the booking after which the host is obligated to
          refund the tenant.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof is not responsible for the administration of security
          deposits, cleaning fees and any other extra fees or for any claims
          asserted by the host.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The host will be responsible for refunding the security deposit to the
          tenant at the end of the lease.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          13. Rental, Lease or Sublease Agreement
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Rental, Lease or Sublease Agreement is created when the Host and
          the Tenant agree to the terms for the Tenant’s occupation of the
          Accommodation. The Rental, Lease or Sublease Agreement shall be
          entered into between the Tenant and Host, and Nomadroof is not a party
          to any of these agreements.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof shall not be responsible or liable for any failure or
          deficiency in the performance of the Rental, Lease or Sublease
          Agreement by the Host and/or for any defect in any Accommodation
          provided by the Host.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof shall not be responsible or liable for any failure or
          deficiency in performance of any contract by the Tenant, including,
          but not limited to, changes in Contract Check-in Date and/or check-out
          dates. The Host must utilize its own resources to enforce any aspect
          of the Rental, Lease or Sublease Agreement (including Contract
          Check-in Date and check-out dates) with the Tenant. Nomadroof shall
          have no responsibility to the Host for any performance failure on the
          part of a Tenant.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          14. Collecting the remaining monthly rent payments
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          After the Tenant has either signed a Rental, Lease or Sublease
          Agreement or other definitive legal document with the Host, or has
          moved in, it is the responsibility of the Host to collect the rent
          each month. Nomadroof takes no responsibility for the collection of
          the following rent installments.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          15. Your Conduct
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          In making any Booking Request and authorizing the Service Fee, First
          Month’s Rent Payment (and the Reservation Deposit, (if applicable) for
          an Accommodation, the Tenant agrees that he/she shall not seek to
          circumvent Nomadroof by attempting to arrange a Booking with the Host
          outside of the auspices of Nomadroof.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          In using the Site, Application and/or Services, and/or accepting any
          introduction of a Tenant for a selected Accommodation, the Host agrees
          that it shall not seek to circumvent Nomadroof by trying to arrange a
          Booking with the Tenant directly and outside of the auspices of
          Nomadroof. Nomadroof reserves the right to deactivate a Host’s account
          at any time for any reason.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          By downloading and/or using the Website, you agree not to upload,
          post, email or otherwise send or transmit any material that contains
          viruses, Trojan horses, worms or any other computer code, files or
          programs designed to interrupt, destroy or limit the functionality of
          any computer software or hardware or telecommunications equipment
          associated with the Services or the Nomadroof site and applications.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Users agree to keep their username and password confidential, not to
          disclose their password to any other person and not to permit any
          other person to log in to the Nomadroof Site or application using
          their username and password.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          You agree not to interfere with the servers or networks connected to
          the Nomadroof’s Site and/or Application or to violate any of the
          procedures, policies or regulations of networks connected to the Site
          and Application, including these Terms and Conditions. You also agree
          not to
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (a)
          </span>
          <span className="text-xs">
            attempt to reverse engineer or sell, export, license, modify, copy,
            distribute or transmit the Site and Application to any third party,
            to jeopardize the functioning of the Site and Application, or to
            otherwise attempt to derive the source code of the software
            (including the tools, methods, processes and infrastructure) that
            enables or underlies the site and application;
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (b)
          </span>
          <span className="text-xs">
            attempt to gain access to secured portions of the site or
            application to which you do not possess access rights;
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (c)
          </span>
          <span className="text-xs">
            impersonate any other person while using the Nomadroof site or
            application;
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (d)
          </span>
          <span className="text-xs">
            conduct yourself in a vulgar, offensive, harassing or objectionable
            manner while using the Nomadroof site or application;
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (e)
          </span>
          <span className="text-xs">
            resell or export the software associated with the Nomadroof site and
            application;
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (f)
          </span>
          <span className="text-xs">
            use the Nomadroof site and application to generate unsolicited
            advertisements or spam; or
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (g)
          </span>
          <span className="text-xs">
            use any automatic or manual process to search or harvest information
            from the Nomadroof site and application, or to interfere in any way
            with the proper functioning of the site and application.
          </span>
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          16. Nomadroof’s Rights
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          In providing you with access to the Site and Application, Nomadroof
          reserves the following rights, and in accessing, browsing or otherwise
          using the Site, Application and/or Services you grant to Nomadroof and
          agree that Nomadroof shall have the following rights:
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (a)
          </span>
          <span className="text-xs">
            the right to refuse or withdraw your access to the Nomadroof Site
            and Application for any reason at any time (with or without notice)
            if in Nomadroof’s sole and absolute discretion you violate or breach
            any of these Terms and Conditions;
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (b)
          </span>
          <span className="text-xs">
            the right to suspend, amend or disable your profile without giving
            you notice or any reason;
          </span>
        </p>
        <p className="mt-2">
          <span className="text-gray-400 dark:text-gray-100 font-bold text-sm mb-2 mr-1">
            (c)
          </span>
          <span className="text-xs">
            the right to report you to the police or other judicial body
            ifNomadroof believes in its sole and absolute discretion that your
            conduct (whether in using the Site, Application, our Services or
            otherwise) is unlawful.
          </span>
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          17. Nomadroof’s Intellectual Property
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof and/or its licensor(s) are the sole owners of the Site,
          Application and Services, which includes any software, domains, and
          content made available through the Site, Application and Services. The
          Site, Application and Services of Nomadroof are protected by U.S. and
          international copyright and other intellectual property laws.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Without limitation, this means that you may not sell, export, license,
          modify, copy, distribute or transmit the Nomadroof Site, Application
          and Services (or any part of it) or any material provided through the
          them without Nomadroof’s prior express written consent.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof and its graphics, logos, icons and service names related to
          the Site, Application and Services are registered and unregistered
          trademarks or trade dress of Nomadroof. They may not be used without
          Nomadroofs prior express written permission.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          You agree that Nomadroof owns the copyright for any marketing material
          and content, whether textual, graphic, photographic or video that it
          creates and publishes on its website and you may not sell, export,
          license, modify, copy, distribute or transmit this content to any
          third party.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          You grant Nomadroof a royalty free, non-exclusive, non-transferable,
          irrevocable, worldwide licence to use your intellectual property
          rights solely to the extent necessary to allow Nomadroof to provide
          the Services to you. For clarity, such use might include such matters
          as displaying your name and logo next to an Accommodation listing, or
          providing a link to your website.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Additionally, you grant us a royalty free, non-exclusive,
          non-transferable, irrevocable during the term of this Agreement,
          worldwide licence to use your intellectual property rights in your
          name, logo and brand get-up (your “Brand”) for the purposes of
          promoting the Service by means of referring on the Site, Application
          and Services, and in our public statements and publicity material to
          the fact of your participation in the Service, provided that in doing
          so we use reasonable efforts to ensure that we do not do anything
          which damages the goodwill in your Brand.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          18. Security
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof has implemented commercially reasonable technical and
          organizational measures to secure your personal information and user
          content from unauthorized use, but we do not guarantee that
          unauthorized third parties will never be able to defeat those
          measures. You acknowledge that you provide your personal information
          and user content at your own risk.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          19. Links
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The Site, Application and Services may contain links to third-party
          websites or resources. You acknowledge and agree that Nomadroof is not
          responsible or liable for: (i) the availability or accuracy of such
          websites or resources; or (ii) the content, products, or services on
          or available from such websites or resources. Links to such websites
          or resources do not imply any endorsement by Nomadroof of such
          websites or resources or the content, products, or services available
          from such websites or resources. You acknowledge sole responsibility
          for and assume all risk arising from your use of any such websites or
          resources or the Content, products or services on or available from
          such websites or resources.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Some portions of the Nomadroof Platform implement Google Maps/Earth
          mapping services, including Google Maps API(s). Your use of Google
          Maps/Earth is subject to Google’s terms of use, located at,
          [http://www.google.com/intl/en_us/help/terms_maps.html].
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          20. Electronic Communications
        </p>
        <ul className="list-disc pl-5 text-xs text-gray-800 dark:text-gray-100 space-y-2">
          <li>
            By downloading and/or using the Site, Application and Services
            and/or material provided through the Site, Application and Services,
            you consent to receiving electronic communications and notices from
            Nomadroof. You agree that any notice, agreement, disclosure or other
            communications that we send to you electronically will satisfy any
            legal communication requirements, including that such communications
            be in writing. You have the right to ask us not to process your
            personal data for such marketing purposes. You can exercise your
            right to prevent such processing by checking certain boxes on the
            forms we use to collect your data. You can also exercise the right
            at any time by contacting us at customersupport@nomadroof.com
          </li>
        </ul>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          21. Privacy
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          You provide us with information when you register on the Site,
          Application and/or Services. We also collect information both relating
          to you (for example on your usage history and your preferences for
          certain kinds of offer) and to users of the Site, Application and the
          Services in general. Any information that you submit or that we
          collect when you are using the Site, Application and/or Services is
          subject to our Cookie Policy, the terms of which are incorporated
          subject to our Cookie Policy, the terms of which are hereby
          incorporated into these Terms and Conditions.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          22. Cookie Policy
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof makes use of cookies. We place cookies to enhance the user
          comfort and make our website as interesting and useful as possible to
          you. One of the purposes of our cookies is to make sure our website
          works optimally and prevents us from showing you information that you
          have already seen before. We emphasize that the use of cookies is
          safe. It is impossible to obtain personal information, such as
          telephone numbers or email addresses via our cookies. Our cookies can
          therefore not be used for email or telemarketing actions.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          The following cookies are used by Nomadroof:
        </p>
        <ul className="list-disc pl-5 text-xs text-gray-800 dark:text-gray-100 space-y-2">
          <li>Functional cookies</li>
          <li>Cookies that make sure that our website works properly</li>
          <li>Analytics</li>
          <li>Cookies that enable us to measure the usage of our website</li>
          <li>Social media</li>
          <li>
            Cookies used to share the content of Site and Application on social
            media or any related website
          </li>
          <li>Recommendations</li>
          <li>
            Cookies used to make more directed recommendations for you as a user
          </li>
        </ul>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          By using the Site, application and/or Services of Nomadroof, you
          consent to the use of cookies in accordance with this cookie policy.
          If you do not agree to our use of cookies, you should set your browser
          settings accordingly, or not use the Nomadroof Site and Application.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          However, be aware that disabling the cookies used for our Site and
          Application, may impact your user experience of the Nomadroof
          platform.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          23. No Warranty/Liability Limit
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof assumes no liability or responsibility for any errors or
          omissions in the Nomadroof Site, Applications or provision of the
          Services; any failures, delays or interruptions in the Site and
          Application; any losses or damages arising from the use of the
          Services or Site and Application; any conduct by users of the Services
          or Site and Application; or any liability of a Host arising from the
          immigration status of any Tenant. We reserve the right to deliver the
          Site, Application and Services in our sole and absolute discretion.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof shall have no liability to a Tenant or Host beyond the sum
          total of the service fee paid by a Tenant or host fee paid by a Host.
          By using this site, you agree to this limitation of liability.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          From time to time you may use or access services, promotions and
          websites of third parties (including without limitation Hosts). In
          using or accessing third party services, promotions and websites, you
          agree to be bound by the terms of service of such third parties
          governing their services, promotions and websites and hereby
          acknowledge that we shall not be responsible for the provision of
          services, accuracy of promotions or content of websites belonging or
          operated by third parties.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          From time to time Nomadroof may run promotions or incentives for the
          benefit of our Site and Application visitors, potential customers and
          customers. Nomadroof reserves the right to modify or remove these
          promotions at any time and may cancel any benefits or monetary
          payments under any promotion.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          If any applicable authority holds any portion of this section to be
          unenforceable, then liability will be limited to the fullest possible
          extent permitted by applicable law.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          24. Disputes
        </p>
        <ul className="list-disc pl-5 text-xs text-gray-800 dark:text-gray-100 space-y-2">
          <li>
            By using Nomadroof’s Site, Application and Services, you agree that
            these Terms and Conditions and any claim, dispute or controversy
            arising out of in connection with these Terms and Conditions or
            their subject matter or formation (including non-contractual
            disputes or claims), the Site, the Application, the Services,
            Nomadroof’s advertising or any related transaction between you and
            Nomadroof shall be governed by and construed in accordance with the
            law of the State of Florida.{" "}
          </li>
          <li>
            Any dispute or claim arising out of or in connection with such
            matters (including non-contractual disputes or claims) will be
            subject to resolution conducted under the auspices of the American
            Arbitration Association in an arbitration proceeding conducted in
            Miami, Florida.
          </li>
        </ul>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          25. Termination
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Nomadroof may change or discontinue the Site, Applications and/or
          Services at any time without prior notice. We reserve the right to
          terminate these Terms and Conditions for any reason, without notice.
          these Terms and Conditions shall automatically terminate in the event
          that you violate any of the Terms and Conditions set forth herein
          (without prejudice to our accumulated rights against you). In the
          event of any termination, you will immediately cease use of the Site,
          Application and/or Services.
        </p>
        <p className="text-gray-400 dark:text-gray-100 mt-2 font-bold text-sm mb-2">
          26. General
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          These Terms and Conditions are agreed between you and Nomadroof. No
          person shall have any rights under or in connection with these Terms
          and Conditions.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          If any court or competent authority decides that any term of these
          Terms and Conditions is invalid, unlawful or unenforceable to any
          extent, such term shall, to that extent only, be severed from the
          remaining terms, which shall continue to be valid to the fullest
          extent permitted by law{" "}
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Headings are for reference purposes only and in no way define, limit,
          construe or describe the extent or scope of such section.
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          Our failure to enforce any provision of these Terms and Conditions
          shall not constitute a waiver of that or any other provision and will
          not relieve you from the obligation to comply with such provision{" "}
        </p>
        <p className="text-xs text-gray-800 dark:text-gray-100 mt-2">
          These Terms and Conditions and the Cookie Policy hereby incorporated
          into these Terms and Conditions, constitute the entire agreement
          between you and Nomadroof and supersede and extinguish all previous
          agreements, promises, assurances, warranties, representations and
          understanding between us, whether written or oral, relating to its
          subject matter.{" "}
        </p>
      </div>
    </div>
  );
};

export default Terms_condition;
